export default __webpack_public_path__ + "static/media/input_delete_ico.a753b70b.svg";